import axios from '../http'
import {API} from "../const"

const api = API + '/shipping-address';
const regionApi = API + '/regions/tree';
const linshiApi = API + '/orders';

const error = (name) => (e) => console.error(name + ':=>', e);

export function getIfShowAddBtn(params, cb, fcb = error('getIfShowAddBtn')) {
    axios.get(linshiApi + '/linshi-address', {params}).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}

export function listAddress(cb, fcb = error('listAddress')) {
    axios.get(api).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}


export function updateDefaultAddress(id, cb, fcb = error('listAddress')) {
    axios.put(api + "/" + id).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}

export function regionList(cb, fcb = error('regionList')) {
    axios.get(regionApi).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}


export function saveShippingAddress(params, cb, fcb = error('saveAddress')) {
    axios.post(api, params).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}

export function updateShippingAddress(id, params, cb, fcb = error('updateShippingAddress')) {
    axios.post(api + "/" + id, params).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}

export function shippingAddressDetail(params, cb, fcb = error('shippingAddressDetail')) {
    axios.get(api + '/' + params).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}

export function deleteShippingAddress(params, cb, fcb = error('deleteShippingAddress')) {
    axios.delete(api + '/' + params).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}



export async function canAdd() {
    return (axios.get(`${api}/can-add`)).then(r=>r.data)
}